module.exports = __webpack_public_path__ + "static/media/5_sthlm barn.ffbfb449.jpg";